import { takeEvery } from "redux-saga/effects";

import { fetchUserPassengersSaga } from "./fetchUserPassengersSaga";
import { fetchUserPassengers } from "../reducer";
import { getConfigTenant, isCorpTenant } from "@capone/common";
import { fetchCorpUserPassengersSaga } from "./capone-corporate/fetchCorpUserPassengersSaga";

export function* watchFetchUserPassengers() {
  yield takeEvery(
    fetchUserPassengers,
    isCorpTenant(getConfigTenant())
      ? fetchCorpUserPassengersSaga
      : fetchUserPassengersSaga
  );
}
